import React, { Fragment, Component } from "react";
import { Navbar, NavItem, Nav, NavDropdown, MenuItem } from "react-bootstrap";
import { Logout } from "react-cognito";
import { LinkContainer } from "react-router-bootstrap";
import { Link, withRouter } from "react-router-dom";
import MediaQuery from "react-responsive";
import { connect } from "react-redux";
import axios from "../../../services/axios-service";

import "./header.css";
import logo from "../../../assets/images/logo-white.svg";
import logoMobile from "../../../assets/images/logo-white-mobile.svg";
import notificationIcon from "../../../assets/images/notification.svg";
import profilepicture from "../../../assets/images/prof-pic.png";
import profileIcon from "../../../assets/images/profile-icon.png";
import logoutIcon from "../../../assets/images/log-out-icon.png";
// import clientReportIcon from '../../../assets/images/report.svg';
import interviewSchedulerIcon from "../../../assets/images/interview_icon.svg";
import clientInterviewSchedularIcon from "../../../assets/images/client-interview-schedular-icon.svg";
import clientInterviewSchedularIconblur from "../../../assets/images/client-interview-schedular-icon-blur.svg";
import clientJobIcon from "../../../assets/images/clientJobActive.svg";
import clientJobIconblur from "../../../assets/images/clientJobBlur.svg";
import clientReportIconblur from "../../../assets/images/client-report-icon.svg";
import clientReportIcon from "../../../assets/images/client-report-icon-active.svg";
import * as actions from "../../../store/actions/index";
import Notification from "../../UI/Notification/Notification";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import config from "../../../config";

/**
 * @desc Header section for recruiter
 * @version 1.0.1
 * @author Lakshmikanth,Jamshith
 */
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      fullName:
        this.props.clientDetails.user_fname &&
        this.props.clientDetails.user_lname
          ? this.props.clientDetails.user_fname +
            " " +
            this.props.clientDetails.user_lname
          : "",
      profileImage: this.props.userImageSignedUrl
        ? this.props.userImageSignedUrl
        : profilepicture,
      user: this.props.groups.includes("client")
        ? "client"
        : this.props.groups.includes("recruiter")
        ? "recruiter"
        : this.props.groups.includes("admin")
        ? "admin"
        : "guest",
      showNotification: false,
      notifications: [],
      isNotificationRead: false,
      unreadCount: 0,
      isActive: false,
      userId: null
    };
    
    this.getnotification = this.getnotification.bind(this);
    this.removeNotification = this.removeNotification.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    this.getnotification();
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  /**
   * @desc changes the user details on update
   * @param prevProps
   * @return null
   */
  componentDidUpdate(prevProps) {
    if (
      this.props.userImageSignedUrl &&
      this.props.userImageSignedUrl === null &&
      (this.props.clientDetails.user_image_url !== null ||
        this.props.clientDetails.user_image_url !== "") &&
      this.props.user !== prevProps.user
    ) {
      this.props.onUpdateProfileImage(
        this.props.clientDetails.user_image_url,
        this.props.user
      );
    }

    if (
      this.props.userImageSignedUrl &&
      this.props.userImageSignedUrl !== prevProps.userImageSignedUrl
    ) {
      this.setState({ profileImage: this.props.userImageSignedUrl });
    }

    if (
      (this.state.fullName === "" ||
        this.props.clientDetails.user_fname !==
          prevProps.clientDetails.user_fname ||
        this.props.clientDetails.user_lname !==
          prevProps.clientDetails.user_lname) &&
      Object.keys(this.props.clientDetails).length > 0
    ) {
      const fullName =
        this.props.clientDetails.user_fname !== "" &&
        this.props.clientDetails.user_lname !== ""
          ? this.props.clientDetails.user_fname +
            " " +
            this.props.clientDetails.user_lname
          : this.props.clientDetails.user_email;
      this.setState({
        fullName: fullName,
        userId: this.props.clientDetails.user_id
      });
    }
    if (this.props.clientDetails.user_id !== prevProps.clientDetails.user_id) {
      this.getnotification();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  handleClickOutside = event => {
    if (
      this.state.showNotification &&
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target)
    ) {
      const notifications = [...this.state.notifications];
      notifications.map(notification => (notification.status = "READ"));
      this.setState({ showNotification: false, notifications: notifications });
    }
  };

  getnotification() {
    if (this.props.clientDetails.user_id) {
      axios
        .get(
          "/galaxy/user/" + this.props.clientDetails.user_id + "/notification"
        )
        .then(response => {
          //ConsoleLog("response notification",response);
          const unreadCount =
            response.data.length > 0 ? response.data[0].unreadCount : 0;
          //ConsoleLog("Notification unread count",unreadCount);
          this.setState({
            notifications: response.data,
            unreadCount: unreadCount
          });
        })
        .catch(error => {
          ConsoleLog(error);
          throw error;
        });
    }
  }
  /**
   * @desc Actual rendering of the component
   * @param null
   * @return DOM element
   */

  showNotification = () => {
    this.setState({ unreadCount: 0 });
    const showNotification = !this.state.showNotification;
    const notifications = [...this.state.notifications];
    if (showNotification) {
      const notifications = [...this.state.notifications];
      if (notifications.find(notification => notification.status === "NEW")) {
        const requestArray = notifications.map(notification => {
          return {
            notificationId: notification.id,
            datetime: notification.datetime
          };
        });
        axios
          .post(
            "/galaxy/user/" + this.state.userId + "/notification",
            JSON.stringify(requestArray)
          )
          .then(response => {
            if (response.data.message === "success") {
              this.setState({ isNotificationRead: true });
            }
          })
          .catch(error => {
            ConsoleLog(error);
            throw error;
          });
      }
    } else {
      notifications.map(notification => (notification.status = "READ"));
    }

    this.setState({
      showNotification: !this.state.showNotification,
      notifications: notifications
    });
  };

  ClearNotification = deleteArray => {
    const notifications = [...this.state.notifications];
    // const timeout = ((0.3 + (notifications.length * 0.1)) * 1000);
    setTimeout(() => {
      this.setState({ notifications: [] });
    }, 1200);
    axios
      .post(
        "/galaxy/user/" + this.state.userId + "/notification",
        JSON.stringify(deleteArray)
      )
      .then(response => {
        if (response.data.message !== "success") {
          this.setState({ notifications: notifications });
        }
      })
      .catch(error => {
        ConsoleLog(error);
        this.setState({ notifications: notifications });
        throw error;
      });
  };

  // removing single notification card
  removeNotification = notificationId => {
    const notifications = [...this.state.notifications];
    const requestArray = notifications.find(
      notification => notification.id === notificationId
    );
    const requestArrayIndex = notifications.indexOf(requestArray);
    const deleteArray = [
      {
        notificationId: requestArray.id,
        datetime: requestArray.datetime,
        remove: 1
      }
    ];
    axios
      .post(
        "/galaxy/user/" + this.state.userId + "/notification",
        JSON.stringify(deleteArray)
      )
      .then(response => {
        if (response.data.message === "success") {
          notifications.splice(requestArrayIndex, 1);
          this.setState({ notifications: notifications });
        }
      })
      .catch(error => {
        ConsoleLog(error);
        throw error;
      });
  };

  handleHeaderClick = action => {
    let nextPath = "";
    switch (action) {
      case "job":
        nextPath =
          this.state.user === "client"
            ? "/account"
            : "/recruiter/pool-view-all";
        break;

      case "interviews":
        nextPath =
          this.state.user == "client"
            ? "/interviews"
            : "/recruiter/interview-scheduler";
        break;

      case "reports":
        nextPath =
          this.state.user == "client"
            ? "/report"
            : "/recruiter/recruiter-all-reports";
        break;

      case "logo":
        nextPath =
          this.state.user == "client"
            ? "/account"
            : this.state.user == "recruiter"
            ? "/recruiter/dashboard"
            : "/account";

      // case 'profilesettings':
      //   nextPath = "/profile-settings";
      //   break;

      default:
        break;
    }

    if (
      this.props.location.pathname === "/interview" ||
      this.props.location.pathname === "/recruiter/interview"
    ) {
      this.props.onPageDataLoss(true, nextPath);
    } else {
      this.props.history.push(nextPath);
    }
  };

  render() {
    const urlArray = window.location.href.split("/");
    ConsoleLog(urlArray);
    const reportDisabled =
      urlArray[3] && urlArray[3] === "report" ? true : false;

    const activeInterviewIconClass =
      urlArray[3] == "interviews" ||
      urlArray[3] == "interview" ||
      urlArray[4] == "interview-scheduler"
        ? "interview-icon-green"
        : "interview-icon-white";

    const activeReportIconClass =
      urlArray[3] == "report" || urlArray[4] == "recruiter-all-reports"
        ? "report-icon-green"
        : "interview-icon-white";

    const activeJobIconClass =
      urlArray[3] == "" || urlArray[3] == "#" || urlArray[4] == "pool-view-all"
        ? "job-icon-green"
        : "interview-icon-white";

    const activeInterviewIcon =
      urlArray[3] == "interviews" ||
      urlArray[3] == "interview" ||
      urlArray[4] == "interview-scheduler"
        ? clientInterviewSchedularIcon
        : clientInterviewSchedularIconblur;
    const activeJobIcon =
      urlArray[3] == "" || urlArray[4] == "pool-view-all"
        ? clientJobIcon
        : clientJobIconblur;
    const activeReportIcon =
      urlArray[3] == "report" || urlArray[4] == "recruiter-all-reports"
        ? clientReportIcon
        : clientReportIconblur;

    // ConsoleLog("config status", !config.InterviewSchedulerFilter.includes(this.props.user.username))
    return (
      <Navbar inverse collapseOnSelect className="common-navbar">
        {/* mobile view starts */}
        <MediaQuery query="(max-device-width: 769px)">
          <div className="mobile-header">
            {this.state.user == "client" || this.state.user == "recruiter" ? (
              <div className="clients-jobs-icon">
                <NavItem className={"current-item " + activeJobIconClass}>
                  {/* <Link to={this.state.user == "client"? "/account" : "/recruiter/pool-view-all"}>
                      <div className={activeJobIconClass}>
                        <img className="header-logo" src={activeJobIcon}/>
                        <Navbar.Text>Jobs</Navbar.Text>
                      </div>
                    </Link> */}
                  <div onClick={() => this.handleHeaderClick("job")}>
                    <div className={activeJobIconClass}>
                      <img className="header-logo" src={activeJobIcon} />
                      <Navbar.Text>Jobs</Navbar.Text>
                    </div>
                  </div>
                </NavItem>
              </div>
            ) : (
              ""
            )}
            {/* Mobile interview scheduler icon removed for Galaxy Singapore */}
            {/* {this.state.user == "client" || this.state.user == "recruiter" ? 
              (
                <div className="interviews-icon">
                  <NavItem className={"current-item " + activeInterviewIconClass}>
                    <div onClick={() => this.handleHeaderClick("interviews")}>
                      <div className={activeInterviewIconClass}>
                        <img
                          className="client-interview-schedular-icon"
                          src={activeInterviewIcon}
                        />
                        <Navbar.Text>Interviews</Navbar.Text>
                      </div>
                    </div>
                  </NavItem>
                </div>
              ) 
              : 
              ("")
            } */}

            {this.state.user == "client" || this.state.user == "recruiter" ? (
              <div className="reports-icon">
                <NavItem className={"current-item " + activeReportIconClass}>
                  {/* <Link to={this.state.user == "client"? "/report" : "/recruiter/recruiter-all-reports"}>
                    <div className={activeReportIconClass}>
                      <img
                        className="client-report-icon"
                        src={activeReportIcon}
                        onClick={e =>
                          reportDisabled ? e.preventDefault() : " "
                        }
                      />
                      <Navbar.Text>Reports</Navbar.Text>
                    </div>
                  </Link> */}
                  <div onClick={() => this.handleHeaderClick("reports")}>
                    <div className={activeReportIconClass}>
                      <img
                        className="client-report-icon"
                        src={activeReportIcon}
                        onClick={e =>
                          reportDisabled ? e.preventDefault() : " "
                        }
                      />
                      <Navbar.Text>Reports</Navbar.Text>
                    </div>
                  </div>
                </NavItem>
              </div>
            ) : (
              ""
            )}

            {(this.state.user == "client" || this.state.user == "recruiter") &&
            !this.props.isSimpleLayout ? (
              <div
                className="recruiter-notification-icon-wrap"
                ref={this.setWrapperRef}
                onClick={this.handleClickOutside}
              >
                {this.state.unreadCount > 0 ? (
                  <div className="notification-count">
                    {this.state.unreadCount}
                  </div>
                ) : (
                  ""
                )}
                <img
                  className="rec-notification-logo"
                  src={notificationIcon}
                  onClick={() => this.showNotification()}
                />
                <Notification
                  showNotification={this.state.showNotification}
                  notifications={this.state.notifications}
                  handleClearNotification={this.ClearNotification}
                  handleRemoveNotification={this.removeNotification}
                />
              </div>
            ) : (
              ""
            )}
            {(this.state.user == "client" || this.state.user == "recruiter") &&
            !this.props.isSimpleLayout ? (
              <div className="client-main-menu">
                <NavDropdown
                  eventKey={2.1}
                  id="jobtitle-nav-dropdown"
                  title={
                    <img className="profilepic" src={this.state.profileImage} />
                  }
                >
                  <div className="arrow-up"></div>
                  <LinkContainer to="/profile-settings">
                    <MenuItem eventKey={2.2}>
                      <span className="menu-icon">
                        <img src={profileIcon} />
                      </span>
                      Profile Settings
                    </MenuItem>
                  </LinkContainer>
                  <div className="menu-line"></div>
                  <Logout
                    onLogout={() => {
                      axios
                        .post("/galaxy/user/activity", {
                          email: this.props.user.username,
                          activity: "LOGOUT"
                        })
                        .then(resp => {})
                        .catch(err => ConsoleLog(err));
                    }}
                  >
                    <LinkContainer to="/recruiter/dashboard">
                      <MenuItem eventKey={2.3}>
                        <span className="menu-icon-logout">
                          <img src={logoutIcon} />
                        </span>
                        Logout
                      </MenuItem>
                    </LinkContainer>
                  </Logout>
                </NavDropdown>
              </div>
            ) : (
              ""
            )}
          </div>
        </MediaQuery>
        {/* mobile view ends */}
{console.log("user type", this.state.user + this.props.isSimpleLayout)}
        {/* desktop view starts */}
        <MediaQuery query="(min-device-width: 768px)">
          <Navbar.Header>
            <Navbar.Brand>
              {/* <Link to={this.state.user == "client" ? "/account" : this.state.user == "recruiter" ?  "/recruiter/dashboard":"/account"}
              >
                {!this.props.isSimpleLayout ? 
                  <img className="header-logo" 
                    src={logo} 
                    onClick={()=>this.getnotification()}
                  /> : ""
                }
              </Link> */}
              <div onClick={() => this.handleHeaderClick("logo")}>
                {!this.props.isSimpleLayout ? (
                  <img
                    className="header-logo"
                    src={logo}
                    onClick={() => this.getnotification()}
                  />
                ) : (
                  ""
                )}
              </div>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>
            <Nav
              pullRight
              className={
                this.state.user == "recruiter"
                  ? "rec-nav-dropdown"
                  : "cli-nav-dropdown"
              }
            >
              {this.state.user == "client" || this.state.user == "recruiter" ? (
                <div className="clients-jobs-icon">
                  <NavItem className={"current-item " + activeJobIconClass}>
                    {/* <Link to={this.state.user == "client"? "/account" : "/recruiter/pool-view-all"}>
                    <div className={activeJobIconClass}>
                      <img className="header-logo" src={activeJobIcon}/>
                      <Navbar.Text>Jobs</Navbar.Text>
                    </div>
                  </Link> */}
                    <div onClick={() => this.handleHeaderClick("job")}>
                      <div className={activeJobIconClass}>
                        <img className="header-logo" src={activeJobIcon} />
                        <Navbar.Text>Jobs</Navbar.Text>
                      </div>
                    </div>
                  </NavItem>
                </div>
              ) : (
                ""
              )}

              {/* Desktop interview scheduler icon removed for Galaxy Singapore */}
              {/* {
              this.state.user == "client" || this.state.user == "recruiter" ? 
                (
                  <div className="interviews-icon">
                    <NavItem
                      className={"current-item " + activeInterviewIconClass}
                    >
                      <div onClick={() => this.handleHeaderClick("interviews")}>
                        <div className={activeInterviewIconClass}>
                          <img
                            className="client-interview-schedular-icon"
                            src={activeInterviewIcon}
                          />
                          <Navbar.Text>Interviews</Navbar.Text>
                        </div>
                      </div>
                    </NavItem>
                  </div>
                  ) 
                : 
                ("")
              } */}

              {(this.state.user == "client" ||
                this.state.user == "recruiter") &&
              !this.props.isSimpleLayout ? (
                <div className="reports-icon">
                  <NavItem
                    className={"current-item " + activeReportIconClass}
                    disabled={reportDisabled}
                  >
                    {/* <Link to={this.state.user == "client"? "/report" : "/recruiter/recruiter-all-reports"} >
                  <div className={activeReportIconClass}>
                    <img 
                      className="client-report-icon" 
                      src={activeReportIcon}
                    />
                      <Navbar.Text>Reports</Navbar.Text>
                    </div>
                  </Link> */}
                    <div onClick={() => this.handleHeaderClick("reports")}>
                      <div className={activeReportIconClass}>
                        <img
                          className="client-report-icon"
                          src={activeReportIcon}
                        />
                        <Navbar.Text>Reports</Navbar.Text>
                      </div>
                    </div>
                  </NavItem>
                </div>
              ) : (
                ""
              )}

              {this.state.user == "recruiter" && !this.props.isSimpleLayout ? (
                <NavItem className="rec-notification-icon" eventKey={1}>
                  <div
                    className="recruiter-notification-icon-wrap"
                    ref={this.setWrapperRef}
                    onClick={this.handleClickOutside}
                  >
                    {this.state.unreadCount > 0 ? (
                      <div className="notification-count">
                        {this.state.unreadCount}
                      </div>
                    ) : (
                      ""
                    )}
                    <img
                      className="recruiter-notification-icon"
                      src={notificationIcon}
                      onClick={() => this.showNotification()}
                    />
                    <Notification
                      showNotification={this.state.showNotification}
                      notifications={this.state.notifications}
                      handleClearNotification={this.ClearNotification}
                      handleRemoveNotification={this.removeNotification}
                    />
                  </div>
                </NavItem>
              ) : this.state.user == "client" && !this.props.isSimpleLayout ? (
                <NavItem className="tp" eventKey={1}>
                  <div
                    className="recruiter-notification-icon-wrap"
                    ref={this.setWrapperRef}
                    onClick={this.handleClickOutside}
                  >
                    {this.state.unreadCount > 0 ? (
                      <div className="notification-count">
                        {this.state.unreadCount}
                      </div>
                    ) : (
                      ""
                    )}
                    <img
                      className="header-talent-pool-logo"
                      src={notificationIcon}
                      onClick={() => this.showNotification()}
                    />
                    <Notification
                      showNotification={this.state.showNotification}
                      notifications={this.state.notifications}
                      handleClearNotification={this.ClearNotification}
                      handleRemoveNotification={this.removeNotification}
                    />
                  </div>
                </NavItem>
              ) : (
                ""
              )}
              {this.props.user !== null && this.props.state == "LOGGED_IN" ? (
                <div className="cli-rec-main-menu">
                  <NavItem
                    eventKey={2}
                    className={
                      this.state.user == "recruiter"
                        ? "recruiter-sideMenuB"
                        : "sideMenuB"
                    }
                    to="#"
                  >
                    <img
                      className="rec-profilepic"
                      src={this.state.profileImage}
                    />
                    <NavDropdown
                      eventKey={2.1}
                      title={this.state.fullName}
                      id="basic-nav-dropdown"
                    >
                      <div className="arrow-up"></div>
                      <LinkContainer to="/profile-settings">
                        <MenuItem eventKey={2.2}>
                          <span className="menu-icon">
                            <img src={profileIcon} />
                          </span>
                          Profile Settings
                        </MenuItem>
                      </LinkContainer>
                      <div className="menu-line"></div>
                      <Logout
                        onLogout={() => {
                          axios
                            .post("/galaxy/user/activity", {
                              email: this.props.user.username,
                              activity: "LOGOUT"
                            })
                            .then(resp => {})
                            .catch(err => ConsoleLog(err));
                          this.props.history.push("/account");
                        }}
                      >
                        <LinkContainer to={"/account"}>
                          <MenuItem eventKey={2.3}>
                            <span className="menu-icon-logout">
                              <img src={logoutIcon} />
                            </span>
                            Logout
                          </MenuItem>
                        </LinkContainer>
                      </Logout>
                    </NavDropdown>
                  </NavItem>
                </div>
              ) : (
                ""
              )}
            </Nav>
          </Navbar.Collapse>
        </MediaQuery>
        {/* desktop view ends */}
      </Navbar>
    );
  }
}
/**
 * @desc connecting to redux store
 * @param state
 * @return redux state
 */
const mapStateToProps = state => ({
  state: state.cognito.state,
  user: state.cognito.user,
  clientDetails: state.clientProfile.clientDetails,
  groups: state.cognito.groups,
  userImageSignedUrl: state.clientProfile.userImageSignedUrl,
  interviewListCount: state.clientProfile.interviewListCount,
  pageDataLoss: state.clientProfile.pageDataLoss
});

/**
 * @desc connecting to redux actions
 * @param dispatch
 * @return redux actions
 */
const mapDispatchToProps = dispatch => {
  return {
    onUpdateProfileImage: (userImageUrl, loggedInUser) =>
      dispatch(actions.getProfileImage(userImageUrl, loggedInUser)),
    onPageDataLoss: (pageData, nextPath) =>
      dispatch(actions.setPageDataLoss(pageData, nextPath))
  };
};

const reduxConnector = connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false
});

export default reduxConnector(withRouter(Header));



// WEBPACK FOOTER //
// ./src/components/Common/Header/Header.js